import "../styles/notfound.css";
import React from "react";
import { FaExclamationTriangle } from "react-icons/fa"; // Import an exclamation icon


function NotFoundPage() {
  return (
    <div className="notfound-container">
      <div className="notfounthero">
        <FaExclamationTriangle className="error-icon" />
        <h1>404</h1>
        <p>Oops! The page you're looking for doesn't exist.</p>
        <a href="/" className="home-link">Back to Home</a>
      </div>
    </div>
  );
}

export default NotFoundPage;
